import GSAP from "gsap";
export default class {
  
  constructor() {
    this.elements = {
      menuBtn: document.querySelector(".menu__btn"),
      nav: document.querySelector(".nav__wrapper__mobile"),
      menuIcon: document.querySelector(".menu_icon"),
      menuItems: document.querySelectorAll(".single__menu__item__mobile"),
    };
    this.menuConfig = {
      duration: 0.2,
      ease: "none",
    };
  }
  openMenu() {
    document.body.style.overflow = "hidden";
    GSAP.to(this.elements.nav, {
      opacity: 1,
      ...this.menuConfig,
      onStart: () => {
        this.elements.nav.style.display = "flex";
      },
    });
    GSAP.to(this.elements.menuIcon, {
      rotate: 45,
      transformOrigin: "center center",
      ...this.menuConfig,
    });
    this.elements.menuBtn.classList.add("menu-open");
  }
  closeMenu(closeDuration) {
    document.body.style.overflow = "auto";
    GSAP.to(this.elements.nav, {
      opacity: 0,
      ...this.menuConfig,
      duration: closeDuration,
      onComplete: () => {
        this.elements.nav.style.display = "none";
      },
    });
    GSAP.to(this.elements.menuIcon, {
      rotate: 0,
      transformOrigin: "center center",
      ...this.menuConfig,
    });
    this.elements.menuBtn.classList.remove("menu-open");
  }
  menuToggle() {
    this.elements.menuBtn.addEventListener("click", () => {
      this.elements.menuItems.forEach((el) => {
        el.style.background = "#FFF8EA";
        el.querySelector("span").style.opacity = 1;
        el.style.opacity = 1;
        el.style.height = "";
        el.style.top = "";
      });
      window.scrollTo({ top: 0, behavior: "instant" });
      if (this.elements.menuBtn.classList.contains("menu-open")) {
        this.closeMenu(0.2);
      } else {
        this.openMenu();
      }
    });
  }
}
